import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import { clientSideLinks } from '../clientRoutes';
import CardIcon from '../../../shared/components/icons/CardIcon';

function ClientPaymentsPage() {
  return (
    <DashboardShell role="CLIENT" sideLinks={clientSideLinks}>
      <div className="rounded-3xl bg-white p-6 shadow-sm">
        <h1 className="flex items-center gap-3 text-2xl font-bold text-navy"><CardIcon name="money" className="h-6 w-6" />Payments</h1>
        <p className="mt-2 text-sm text-slate-600">Review invoices, payouts, and payment history.</p>
      </div>
    </DashboardShell>
  );
}

export default ClientPaymentsPage;
